<div class="sidebar-brand">
  <img src="normax-2.png" alt="Normax Capital" style="height: 38px; width: auto; object-fit: contain;" />
  <div class="sidebar-brand-subtitle">CRM &middot; v1.0</div>
</div>
<nav class="sidebar-nav">
  @for (cluster of filteredNav(); track cluster.cluster) {
    <div class="sidebar-cluster">
      <div class="sidebar-cluster-label">{{ cluster.cluster }}</div>
      @for (item of cluster.items; track item.key) {
        <a
          [routerLink]="['/', item.path]"
          class="sidebar-link"
          [class.active]="item.key === activeKey()"
          [attr.data-key]="item.key"
        >
          <span class="sidebar-link-icon" [innerHTML]="iconFor(item.key) | safeHtml"></span>
          <span>{{ item.label }}</span>
        </a>
      }
    </div>
  }
</nav>
<div class="sidebar-footer">
  <a [routerLink]="['/static']" class="sidebar-footer-link">Static reference pages &rarr;</a>
  <div class="sidebar-footer-entity">{{ user().entity }}</div>
  Reg. 969798-7692
</div>

